import * as Types from '../../../../types/gql';

export type UtexBalanceVariables = Types.Exact<{ [key: string]: never }>;

export type UtexBalance = {
  currentUser?: Types.Maybe<{
    utexBalance?: Types.Maybe<{
      totalHumanReadable: { value: string; currency: { code: string; fractionDigits: number } };
    }>;
  }>;
};
